import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";

// Using the same portfolioItems data from your main portfolio page
const portfolioItems = [
  {
    id: 1,
    img: "https://www.mevabite.com/cdn/shop/articles/almendro01.jpg?v=1718274411&width=1100",
    title: "California Almond Orchards",
    description: "Premium almond farms in California delivering high global demand and long-term returns.",
    category: "Agriculture",
    year: "2023",
    details: {
      client: "Almond Growers Cooperative",
      impactArea: "Sustainable Agriculture, Investment",
      work: "Financial Strategy, Process Optimization, Investment Advisory",
      objective: "Enhanced agricultural productivity through optimized design, functionality, and overall farming experience.",
      testimonial: {
        text: "Partnering with Techspear Ventures transformed our almond operations. They delivered thoughtful financial solutions that fully aligned with our long-term agricultural goals.",
        author: "Michael Thompson",
        position: "Operations Director",
        avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80"
      },
      additionalImages: [
        "https://cdn.prod.website-files.com/5e5717f541472a2c2b58bd84/5e5ea338f9286d28f42d934d_Splitting%20Almonds.png",
        "https://www.ft.com/__origami/service/image/v2/images/raw/http%3A%2F%2Fcom.ft.imagepublish.upp-prod-eu.s3.amazonaws.com%2Fdc2efecc-2169-11e8-8d6c-a1920d9e946f?source=next-article&fit=scale-down&quality=highest&width=700&dpr=1"
      ]
    }
  },
  {
    id: 2,
    img: "https://assets.farmjournal.com/dims4/default/1252b0e/2147483647/strip/true/crop/840x561+0+20/resize/800x534!/quality/90/?url=https%3A%2F%2Ffj-corp-pub.s3.us-east-2.amazonaws.com%2Fs3fs-public%2F2023-03%2FCalifornia-avocado-Oppy-Eco-Farms.png",
    title: "Organic Avocado Farm",
    description: "Sustainably grown avocados with rising market value and export potential.",
    category: "Organic Farming",
    year: "2022",
    details: {
      client: "Eco Farms Avocado",
      impactArea: "Organic Agriculture, Export Development",
      work: "Financial Strategy, Market Expansion, Sustainability Consulting",
      objective: "Enhanced organic farming practices through optimized processes, functionality, and overall agricultural experience.",
      testimonial: {
        text: "Techspear Ventures helped us navigate the complexities of organic certification and export markets. Their financial strategies were perfectly tailored to our sustainable farming model.",
        author: "Sarah Johnson",
        position: "CEO",
        avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80"
      },
      additionalImages: [
        "https://common.crowdfarming.com/uploaded-images/1692608755299-fec6043e-d687-4cc9-b4eb-78648ccf86ac.jpg",
        "https://common.crowdfarming.com/uploaded-images/1734967285042-361667a2-96ce-46c6-88e9-729bea5c78d6.jpg"
      ]
    }
  },
  {
    id: 3,
    img: "https://blogs.worldbank.org/content/dam/sites/blogs/img/detail/mgr/forests-jen-watson-shutterstock_1213001860-1000.jpg",
    title: "Sustainable Timber Plantation",
    description: "Eco-friendly timber investments ensuring renewable resources and stable yields.",
    category: "Forestry",
    year: "2021",
    details: {
      client: "GreenWood Resources",
      impactArea: "Sustainable Forestry, Environmental Conservation",
      work: "Financial Strategy, Resource Management, ESG Investment",
      objective: "Enhanced sustainable forestry through optimized design, functionality, and overall management experience.",
      testimonial: {
        text: "The team at Techspear Ventures understood our unique needs in sustainable timber production. Their investment strategies balanced profitability with environmental responsibility.",
        author: "David Chen",
        position: "Forestry Manager",
        avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80"
      },
      additionalImages: [
        "https://www.naturalmangoes.com/wp-content/uploads/2023/01/Mahogany-Tree-Forestry.jpg",
        "https://cf-img-a-in.tosshub.com/lingo/gnt/images/story/202303/mahogany-sixteen_nine.jpg?size=948:533"
      ]
    }
  },
  {
    id: 4,
    img: "https://static.wixstatic.com/media/927754_b7e1de3661cb41fb99c541d8df3cc069~mv2.jpg/v1/fill/w_1068,h_591,al_c/927754_b7e1de3661cb41fb99c541d8df3cc069~mv2.jpg",
    title: "Modern Greenhouse Farming",
    description: "High-tech greenhouse farms maximizing crop yield and year-round profitability.",
    category: "Technology",
    year: "2023",
    details: {
      client: "AgriTech Solutions",
      impactArea: "Agricultural Technology, Year-Round Production",
      work: "Financial Strategy, Technology Implementation, Operational Efficiency",
      objective: "Enhanced greenhouse productivity through optimized design, functionality, and overall farming experience.",
      testimonial: {
        text: "Techspear Ventures' innovative financial approach enabled us to implement cutting-edge greenhouse technology that has revolutionized our year-round production capabilities.",
        author: "Rachel Martinez",
        position: "Technology Director",
        avatar: "https://images.unsplash.com/photo-1552058544-f2b08422138a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80"
      },
      additionalImages: [
        "https://i.ytimg.com/vi/sqIXQoJU5aI/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLCW6qEoU7yIQseRf5mVyF1dp2IIaQ",
        "https://imageio.forbes.com/specials-images/imageserve/5f4853e09aaee8c054483086/Bell-peppers-being-grown-in-greenhouse-in-Zevenbergen--Noord-Brabant--Netherlands/960x0.jpg?height=476&width=711&fit=bounds"
      ]
    }
  }
];

const PortfolioDetail = () => {
  const { id } = useParams();
  const [project, setProject] = useState(null);

  useEffect(() => {
    // Find the project based on the ID from URL parameters
    const foundProject = portfolioItems.find(item => item.id === parseInt(id));
    setProject(foundProject);
  }, [id]);

  if (!project) {
    return (
      <section className="px-4 sm:px-6 lg:px-12 py-12 font-sans text-primaryBgColor tracking-wide min-h-screen flex items-center justify-center">
        <div>Loading project details...</div>
      </section>
    );
  }

  return (
    <section className="px-4 sm:px-6 lg:px-12 py-12 font-sans text-primaryBgColor tracking-wide">
      {/* Back button */}
      <div className="mb-8">
        <Link 
          to="/portfolio" 
          className="inline-flex items-center text-primaryTextColor hover:text-primaryBgColor transition-colors text-sm font-medium"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
          Back to Portfolio
        </Link>
      </div>

      {/* Section 1: Title & Intro */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center border-b pb-8">
        {/* Left Column */}
        <div>
          <h1 className="text-3xl md:text-5xl font-bold mb-4">
            {project.title} overview
          </h1>
        </div>

        {/* Right Column */}
        <div>
          <p className="text-secondaryTextColor text-base md:text-lg leading-relaxed text-justify">
            {project.description} At Techspear Ventures, We Empower Businesses With Innovative
            Financial Solutions That Drive Growth And Success. Our Expert Team
            Collaborates Closely With Clients To Navigate The Complexities Of
            Finance And Optimize Their Operations.
          </p>
        </div>
      </div>

      {/* Section 2: Description & Client Info */}
      <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-10">
        {/* Left Column */}
        <div>
          <h2 className="text-xl md:text-2xl font-semibold leading-snug mb-4">
            We partnered with {project.details.client} to enhance their {project.category.toLowerCase()} strategies and achieve sustainable growth.
          </h2>
        </div>

        {/* Right Column */}
        <div className="grid grid-cols-2 gap-6 text-sm sm:text-base">
          <div>
            <p className="font-semibold text-secondaryTextColor">Client</p>
            <p className="text-primary mt-1">{project.details.client}</p>
          </div>
          <div>
            <p className="font-semibold text-secondaryTextColor">Impact area</p>
            <p className="mt-1">{project.details.impactArea}</p>
          </div>
          <div className="col-span-2">
            <p className="font-semibold text-secondaryTextColor">Work</p>
            <p className="mt-1">
              {project.details.work}
            </p>
          </div>
        </div>
      </div>

      {/* Section 3: Large Image */}
      <div className="mt-10">
        <img
          src={project.img}
          alt={project.title}
          className="rounded-xl w-full h-80 md:h-[550px] object-cover"
        />
      </div>

      {/* Section 4: Key Objective */}
      <div className="mt-12">
        <p className="uppercase text-xs text-gray-400 tracking-wide mb-2">
          Key Objective
        </p>
        <h3
          style={{ lineHeight: "1.2" }}
          className="text-2xl sm:text-3xl md:text-5xl font-bold mb-4"
        >
          <span className="text-[#BDD0C7]">Enhanced engagement:</span> optimizing
          <br />
          design, functionality, and overall experience.
        </h3>
        <p className="text-secondaryTextColor text-base leading-relaxed">
          {project.details.objective} Techspear Ventures Is Dedicated To Empowering Businesses With
          Innovative Financial Solutions That Drive Growth And Success. Our
          Mission Is To Help Clients Navigate The Complexities Of Finance And
          Achieve Sustainable Growth.
        </p>
      </div>

      {/* Section 5: Two Images Side by Side */}
      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="w-full h-72 md:h-96">
          <img
            src={project.details.additionalImages[0]}
            alt={`${project.title} detail 1`}
            className="rounded-xl w-full h-full object-cover"
          />
        </div>
        <div className="w-full h-72 md:h-96">
          <img
            src={project.details.additionalImages[1]}
            alt={`${project.title} detail 2`}
            className="rounded-xl w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Section 6: Testimonial */}
      <div className="max-w-3xl mx-auto text-center mt-12">
        <div className="flex justify-center mb-3">
          <span className="text-primaryBtnHoverColor text-xl">★★★★★</span>
        </div>
        <p className="text-lg italic text-secondaryTextColor mb-6">
          {project.details.testimonial.text}
        </p>
        <div className="flex items-center justify-center space-x-3">
          <img
            src={project.details.testimonial.avatar}
            alt={project.details.testimonial.author}
            className="w-14 h-14 rounded-full object-cover"
          />
          <div className="text-start">
            <div className="text-primaryBgColor text-lg font-bold">{project.details.testimonial.author}</div>
            <div className="text-secondaryTextColor text-sm font-medium opacity-40">{project.details.testimonial.position}, {project.details.client}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioDetail;








// import React from "react";

// const PortfolioDetail = () => {
//   return (
//     <section className="px-4 sm:px-6 lg:px-12 py-12 font-sans text-primaryBgColor tracking-wide">
//       {/* Section 1: Title & Intro */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center border-b pb-8">
//         {/* Left Column */}
//         <div>
//           <h1 className="text-3xl md:text-5xl font-bold mb-4">
//             Project overview
//           </h1>
//         </div>

//         {/* Right Column */}
//         <div>
//           <p className="text-secondaryTextColor text-base md:text-lg leading-relaxed text-justify">
//             At Techspear Ventures, We Empower Businesses With Innovative
//             Financial Solutions That Drive Growth And Success. Our Expert Team
//             Collaborates Closely With Clients To Navigate The Complexities Of
//             Finance And Optimize Their Operations.
//           </p>
//         </div>
//       </div>

//       {/* Section 2: Description & Client Info */}
//       <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-10">
//         {/* Left Column */}
//         <div>
//           <h2 className="text-xl md:text-2xl font-semibold leading-snug mb-4">
//             We partnered with a local startup to enhance their financial
//             strategies and achieve sustainable growth.
//           </h2>
//         </div>

//         {/* Right Column */}
//         <div className="grid grid-cols-2 gap-6 text-sm sm:text-base">
//           <div>
//             <p className="font-semibold text-secondaryTextColor">Client</p>
//             <p className="text-primary mt-1">MoneyFlow</p>
//           </div>
//           <div>
//             <p className="font-semibold text-secondaryTextColor">Impact area</p>
//             <p className="mt-1">Finance, Business Consulting</p>
//           </div>
//           <div className="col-span-2">
//             <p className="font-semibold text-secondaryTextColor">Work</p>
//             <p className="mt-1">
//               Financial Strategy,
//               <br /> Process Optimization,
//               <br /> Investment Advisory
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Section 3: Large Image */}
//       <div className="mt-10">
//         <img
//           src="https://t3.ftcdn.net/jpg/03/28/82/42/360_F_328824244_h8ln41Hd3sh985TASxWVMmZ2w5LYSYvz.jpg"
//           alt="Team meeting"
//           className="rounded-xl w-full object-cover"
//         />
//       </div>

//       {/* Section 4: Key Objective */}
//       <div className="mt-12">
//         <p className="uppercase text-xs text-gray-400 tracking-wide mb-2">
//           Key Objective
//         </p>
//         <h3
//           style={{ lineHeight: "1.2" }}
//           className="text-2xl sm:text-3xl md:text-5xl font-bold mb-4"
//         >
//           <span className="text-[#BDD0C7]">Enhanced engagement:</span> optimizing
//           <br />
//           design, functionality, and overall experience.
//         </h3>
//         <p className="text-secondaryTextColor text-base leading-relaxed">
//           Techspear Ventures, Is Dedicated To Empowering Businesses With
//           Innovative Financial Solutions That Drive Growth And Success. Our
//           Mission Is To Help Clients Navigate The Complexities Of Finance And
//           Achieve Sustainable Growth.
//         </p>
//       </div>

//       {/* Section 5: Two Images Side by Side */}
//       <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
//         <div className="w-full h-72 md:h-96">
//           <img
//             src="https://media.istockphoto.com/id/1398717746/photo/business-team-working-online-at-the-office-using-a-tablet.jpg?s=612x612&w=0&k=20&c=i9wA9QxNc97priUT5gcqDsTtgxwBcYzG3s7IcFdRYxE="
//             alt="Team collaboration"
//             className="rounded-xl w-full h-full object-cover"
//           />
//         </div>
//         <div className="w-full h-72 md:h-96">
//           <img
//             src="https://cdn-shop.adafruit.com/970x728/4112-06.jpg"
//             alt="Keyboard"
//             className="rounded-xl w-full h-full object-cover"
//           />
//         </div>
//       </div>

//       {/* Section 6: Testimonial */}
//       <div className="max-w-3xl mx-auto text-center mt-12">
//         <div className="flex justify-center mb-3">
//           <span className="text-primaryBtnHoverColor text-xl">★★★★★</span>
//         </div>
//         <p className="text-lg italic text-secondaryTextColor mb-6">
//           Partnering with MoneyFlow was a remarkable journey. They listened,
//           understood our needs, and delivered thoughtful solutions that fully
//           aligned with our long-term business goals.
//         </p>
//         <div className="flex items-center justify-center space-x-3">
//           <img
//             src="https://img.freepik.com/free-photo/i-like-that-good-job-happy-young-dark-skinned-female-wearing-casual-long-sleeved-t-shirt-making-thumbs-up-sign-smiling-cheerfully-showing-her-support-respect-someone-body-language_273609-1258.jpg"
//             alt="Client"
//             className="w-14 h-14 rounded-full"
//           />
//           <div className="text-start">
//           <div className="text-primaryBgColor text-lg font-bold">Emma Roberts</div>
//           <div className="text-secondaryTextColor text-sm font-medium opacity-40">Marketing Manager</div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default PortfolioDetail;